track = require 'debug/track'

module.exports = class TabbedPaneView
  switchSection: (e) -> # should be bound to 'click .tabbed-pane-nav-item-button:not(.active)'
    @$('.js-content').addClass('hide').detach()
    @$('.js-loading-page').removeClass('hide')

    @$('.tabbed-pane-nav-item-button').removeClass('active')
    @$(e.target).addClass('active')

    track(@model.typeName + ' View', 'Tab Navigation', 'Open ' + @$(e.target)[0].getAttribute('data-tab') + ' Page')



// WEBPACK FOOTER //
// ./app/scripts/views/internal/tabbed-pane-view.coffee